// SquareButton.tsx – lighter / smaller numerals
import React from "react";
import { Button, useMantineTheme, rem } from "@mantine/core";

interface SquareButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  "aria-label"?: string;
}

export const SquareButton: React.FC<SquareButtonProps> = ({
  children,
  onClick,
  disabled,
  ...rest
}) => {
  const { fontSizes } = useMantineTheme();

  return (
    <Button
      variant="default"
      onClick={onClick}
      disabled={disabled}
      p={0}
      style={{
        width: "100%",
        aspectRatio: "1 / 1",
        fontSize: rem(fontSizes.md), // ≈ 1 rem everywhere
        //fontSize: rem("0.4rem"),
        //fontSize: "1.1rem",
        fontWeight: 600,
        lineHeight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};
